import * as React from 'react';

function SvgSm(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 480"
            width={props.width || 640}
            height={props.height || 480}
            {...props}
        >
            <g fillRule="evenodd" strokeWidth="1pt">
                <path fill="#19b6ef" d="M0 240h640v240H0z" />
                <path fill="#fff" d="M0 0h640v240H0z" />
            </g>
            <path
                d="M317.07 339.221c52.45-39.239 108.96-119.306 42.74-161.41-12.336-2.388-26.107-1.672-32.713 3.582-3.501-1.99-6.288-1.83-9.79 1.91-2.466-3.025-4.935-4.379-10.028-2.865-10.188-5.173-19.42-6.288-31.517-3.105-57.623 34.622-22.366 116.76 41.308 161.888z"
                fillRule="evenodd"
                stroke="#7d6c00"
                strokeWidth={2.369}
                fill="#fd0"
            />
            <g stroke="#3a9d4f">
                <path
                    strokeLinejoin="round"
                    d="M414.08 250.106s5.903-7.939 6.106-7.939c5.904-3.46 6.515-7.938 6.515-7.938 5.903-1.833 4.07-6.718 4.477-7.328 2.852-3.053 1.833-6.108 1.426-7.126 0-.812 2.036-8.345-.814-9.362.135-8.008-4.818-7.261-8.754-2.036-4.207 1.221-5.157 4.682-3.664 8.55-5.497 0-5.7 7.939-4.071 12.416-7.328-.203-3.257 7.939-3.461 8.347-2.442 1.221 1.832 12.824 2.24 12.416zM367.857 318.3l3.664 2.239c.746 2.781 3.325 4.547 5.294 4.072.95 4.274 5.563 3.665 8.956 1.221 2.714 3.936 6.04 4.005 10.586 2.647 4.07 2.985 9.364 1.696 12.824-1.426 3.731 3.053 6.243.815 8.142-2.442 2.917.746 5.224.272 6.31-2.647 5.7-.474 2.85-5.835-1.83-8.142 3.73-3.258 7.87-9.975 2.035-10.993-1.833-1.356-5.292-1.084-7.94.205-.677-2.987-4.818-3.733-9.364-.408-1.56-3.325-6.989-1.764-9.568.611-3.256-2.85-7.124-2.85-12.824.406L367.857 318.3zm0-8.745c.678-3.731-1.9-10.517 2.035-11.195-.746-6.243.34-13.3 7.532-12.621 1.155-5.903.883-11.4 7.736-12.215 0 0 5.497-19.134 11.197-5.903 2.239 3.87 1.832 10.177-2.647 8.956.883 4.751-.678 8.889-5.903 8.754 2.307 3.324 1.56 7.872-1.018 9.976-6.311 4.748-12.62 9.5-18.932 14.248zm33.18-23.82l5.904-1.22c6.106-4.071 8.55-5.7 11.603-1.223 5.089-1.086 9.974-.543 9.771 3.461 6.04.407 5.971 4.274 5.294 7.328.949 5.36-1.358 12.35-5.09 3.867-11.807-7.192-18.525-6.243-37.253-2.035l9.771-10.178zm3.065-5.913c.205-.203 17.507-4.682 15.675-9.974 4.885-.815 5.904-5.7 6.108-5.7 10.177-3.256 9.566-9.161 9.566-9.161 2.918-3.122 8.075-6.243 6.922-11.807.34-6.31.882-10.177-7.532-6.106-6.311-.612-8.55 3.053-10.382 8.55-2.985-3.528-7.802 2.104-8.345 7.124 0 0-7.736 7.532-7.736 7.735s-6.514 12.01-6.514 12.01l2.238 7.33z"
                    fillRule="evenodd"
                    strokeWidth={2.369}
                    fill="#4fd46b"
                />
                <path
                    strokeLinejoin="round"
                    d="M404.502 266.397c-4.14-3.122-6.446-6.853-5.7-10.586-2.713-3.664-4.614-5.903-2.035-9.16 0 0-2.036-7.329-2.036-7.532-5.292-2.035-3.053-6.513-1.629-8.142-2.51-3.461-2.578-7.126-.203-10.382-.068-6.515 4.546-4.071 8.345 0 0 0 6.311 4.479 1.63 8.55 4.681 1.629 6.107 5.698 3.46 7.327 4.071 1.833 4.681 5.497 2.442 7.94 4.14 3.326 2.579 7.465 3.868 11.196l-8.142 10.789z"
                    fillRule="evenodd"
                    strokeWidth={2.369}
                    fill="#4fd46b"
                />
                <path
                    strokeLinejoin="round"
                    d="M411.831 236.064c-.203-.203-6.92-8.753-5.089-9.364-.406-2.647-2.441-5.497-1.22-8.142-3.325-3.325-3.394-7.26-.815-10.38-2.239-3.054-1.221-7.125 1.832-9.772-.95-5.022 2.579-6.175 5.7-7.126 2.307-8.075 6.038-5.971 8.142.203 3.19 2.782 2.715 6.99 1.63 10.18 3.799 2.578 1.492 5.766-.204 7.124l-9.976 27.277z"
                    fillRule="evenodd"
                    strokeWidth={2.369}
                    fill="#4fd46b"
                />
                <path
                    strokeLinejoin="round"
                    d="M410.815 193.106l-5.7-5.7c1.473-3.02 2.659-8.344-1.627-10.789-2.364-5.757-14.182-12.892-16.083.815-1.799-4.136-5.563-8.21-8.345-3.46-6.175-5.292-9.5-3.665-6.311 3.053 0 0-2.848 4.478 4.682 7.939.611.61-2.442 8.142 6.515 8.345-1.696 2.579 1.086 6.175 4.682 5.903-2.579 3.19 1.764 6.583 4.477 5.294-1.154 3.528-1.086 5.225 3.868 5.7l5.497 6.31 4.477 6.106 3.868-29.516z"
                    fillRule="evenodd"
                    strokeWidth={2.369}
                    fill="#4fd46b"
                />
                <path
                    d="M414.28 246.508c.288-.288 10.938-24.757 12.378-32.243M415.43 203.05s1.726 19.864-3.167 34.545m-29.648-54.7s21.879 21.015 23.893 29.651m-8.635-31.95s1.439 17.274 7.484 34.259m31.093 28.488s-21.879 18.425-32.53 34.545m11.792 29.952s-28.788 4.03-41.454 4.318m31.96 8.057s-35.698-.864-38.29-3.454m20.433-42.902c0 .287-18.136 30.226-18.712 40.015"
                    strokeLinecap="round"
                    strokeWidth={2.22}
                    fill="none"
                />
            </g>
            <path
                d="M316.87 333.441c-37.768-35.624-76.454-102.482-37.972-136.27 6.84 3.88 14.903.409 26.03-3.98 3.368 3.674 7.654 4.594 11.942 1.837 4.797 2.042 8.37.408 10.718-2.144 10.922 6.33 24.906 9.596 28.172 3.37 37.87 35.93-.511 103.095-38.89 137.187z"
                fillRule="evenodd"
                stroke="#7d6c00"
                strokeWidth={2.369}
                fill="#65c7ff"
            />
            <path
                d="M317.086 332.408c-16.219-16.307-31.017-34.385-42.347-57.66 1.939-1.632 2.84-2.138 3.861-4.997 5.818.818 8.88 1.021 16.536-.306 1.53 5.717 1.837 10.514 5.511 15.311l7.656-15.005c5.205 1.226 11.637 1.533 16.535 0 3.165 4.288 2.042 10.72 7.656 15.618 3.368-9.9 6.738-10.615 10.106-15.924 5.002 1.736 8.167 1.021 12.25-.307 2.143 2.45 1.072 2.41 4.975 6.007-10.233 20.32-24.265 40.728-42.739 57.263z"
                fillRule="evenodd"
                fill="#8fc753"
            />
            <path
                d="M272.65 164.304a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-3.492-7.71a3.346 3.346 0 11-6.691 0 3.346 3.346 0 016.691 0zm-4.073-7.129a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-2.764-6.983a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm.436-7.564a3.346 3.346 0 11-6.691 0 3.346 3.346 0 016.691 0zm17.663-12.511a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                d="M273.814 123.571a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-7.274 4.364a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm22.403-5.383a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm9.311.728a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm8.292-.437a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                d="M325.874 117.504a8.583 8.583 0 11-17.166 0 8.583 8.583 0 0117.166 0z"
                fillRule="evenodd"
                stroke="#7d6c00"
                strokeWidth={1.111}
                fill="#fd0"
            />
            <path
                d="M334.913 122.698a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm8.729.727a3.346 3.346 0 11-6.691 0 3.346 3.346 0 016.691 0zm8.438-.437a3.346 3.346 0 11-6.693 0 3.346 3.346 0 016.692 0zm7.127-.29a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm8.875 1.018a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm6.982 4.364a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                d="M269.414 151.697c2.85 5.42 5.698 11.05 8.548 16.47h79.23l9.174-15.846c-5.352-3.683-9.035-6.533-16.68-4.795-4.31-6.185-9.035-7.366-16.054-6.671-2.086-2.154-3.963-3.475-7.508-3.961l-16.678.416c-4.38.416-7.716 3.753-7.924 3.753-7.09-.835-13.552-.627-15.22 6.254-6.463-1.599-11.05.14-16.888 4.38z"
                fillRule="evenodd"
                stroke="#ac0000"
                strokeWidth={2.369}
                fill="#e40000"
            />
            <path
                d="M377.974 135.354a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm.582 7.856a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-2.474 7.274a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-3.055 5.964a3.346 3.346 0 11-6.692 0 3.346 3.346 0 016.692 0zm-3.637 7.565a3.346 3.346 0 11-6.69 0 3.346 3.346 0 016.69 0zm-46.824-9.589a4.946 4.946 0 11-9.893 0 4.946 4.946 0 019.893 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                d="M323.546 143.045a5.964 5.964 0 11-11.93 0 5.964 5.964 0 0111.93 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                d="M322.685 131.995a5.383 5.383 0 11-10.765 0 5.383 5.383 0 0110.765 0z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.109}
                fill="#fff"
            />
            <path
                d="M315.487 109.055c0-.926-.028-4.165.037-4.295l-3.572-.064.102-3.175 3.1-.037.037-2.775h4.395v2.544h3.47l-.072 3.378-3.6-.037-.03 4.526-3.867-.065z"
                fillRule="evenodd"
                stroke="#7d6c00"
                strokeWidth={1.111}
                fill="#fd0"
            />
            <path
                d="M277.56 168.17c-7.092-12.023-17.51-28.367-11.053-35.444 8.955-10.143 29.953-.973 43.367-6.881.972 11.468-2.224 30.44 2.92 34.403l-4.796 4.17c-2.92-3.753-8.418-8.782-15.22.208-3.892-3.403-8.316-2.805-10.4 1.72-1.982.267-1.867 1.06-4.819 1.824zm80.12-.416c7.09-12.023 17.51-28.367 11.051-35.444-8.955-10.143-29.952-.973-43.366-6.882-.973 11.469 2.223 30.441-2.92 34.404l4.795 4.17c4.614-6.489 10.373-6.699 15.22.207 3.893-3.403 7.925-2.936 10.4 1.721 1.983.267 1.868 1.06 4.82 1.824z"
                stroke="#fd0"
                strokeWidth={3.331}
                fill="none"
            />
            <path
                d="M277.343 177.132c28.495-2.918 54.904-1.877 79.23 0l3.127-8.967c-27.66-5.003-46.773-5.628-82.982-.624l.625 9.59z"
                fillRule="evenodd"
                stroke="#7d6c00"
                strokeWidth={2.369}
                fill="#fd0"
            />
            <path
                d="M314.121 329.377c.205-1.43.408-2.762.613-4.191 2.834.763 4.996.468 7.35-.402.815-1.225 1.633-2.45 2.45-3.676l-1.838-2.142c-1.615.348-2.941 1.85-3.98 3.158-1.628.077-3.064-.71-4.595-1.016l-1.53-6.43c-1.52-1.795-4.671-1.668-3.982 1.531l.307 2.45c.613 1.531.841 3.639 1.837 4.785v2.511c1.123 1.141 2.246 2.28 3.368 3.422zm1.216-18.29c-2.13 1.056-4.659-.78-7.349-1.837-2.45-.168-4.419 1.872-7.349 1.224.535-1.59 1.837-1.837 2.757-2.756-.673-4.131 1.53-5.512 2.144-5.512.61 0 3.061.613 3.061.613l2.45.306c1.43 2.654 3.433 5.02 4.286 7.962z"
                fillRule="evenodd"
                fill="#c76e2e"
            />
            <path
                d="M300.779 366.089c7.066-11.472 56.259-34.508 102.422-84.251-46.99 45.243-76.357 56.35-114.812 83.974l12.39.277z"
                fillRule="evenodd"
                stroke="#e9bf00"
                strokeWidth={2.369}
                fill="#ffe100"
            />
            <path
                d="M368.406 313.186a3.582 3.582 0 11-7.163 0 3.582 3.582 0 017.163 0zm34.38-34.863a4.06 4.06 0 11-8.118 0 4.06 4.06 0 018.118 0zm11.466-29.61a3.582 3.582 0 11-7.163 0 3.582 3.582 0 017.163 0zM403.02 210.28a3.582 3.582 0 11-7.164 0 3.582 3.582 0 017.164 0z"
                fillRule="evenodd"
                stroke="#68300e"
                strokeWidth={1.111}
                fill="#9d4916"
            />
            <path
                d="M279.125 269.595v-15.148l-1.54-1.283v-3.594l2.824-.257.513-16.945-1.797-1.028-.257-2.823s2.054.77 2.054.257.513-3.339.513-3.339-1.282-.256-1.282-.77 1.539-1.796 1.539-1.796-.77-.772-1.026-1.285-.77-2.823-.77-2.823l.77-2.825-.513-1.54-1.285-2.311 1.798-1.797s-.513-2.31-.513-2.824 1.282-2.567 1.539-2.825c.258-.256 2.312-3.08 2.312-3.08l4.364-1.027 5.135.77 2.824 1.798.513 4.62s-.513 2.824-.77 2.824-2.31 1.028-2.31 1.028-2.569.256-2.825 0 .77 3.081.77 3.081v3.08l-.256 3.851s0 1.798-.258 2.054c-.256.257-.77 1.028-.77 1.028l-.256 3.851 4.108 1.026-.257 2.312-2.825.257.515 15.66 4.108.77v4.366l-1.798 1.026-.513 15.66h-14.378zm62.397.266v-15.148l-1.54-1.282v-3.595l2.824-.256.513-16.945-1.797-1.028-.257-2.823s2.054.77 2.054.256.513-3.338.513-3.338-1.282-.257-1.282-.77 1.539-1.797 1.539-1.797-.77-.771-1.026-1.284-.77-2.823-.77-2.823l.77-2.826-.513-1.54-1.285-2.31 1.798-1.798s-.513-2.31-.513-2.823 1.282-2.567 1.539-2.825c.258-.257 2.312-3.08 2.312-3.08l4.364-1.028 5.135.771 2.824 1.798.513 4.62s-.513 2.824-.77 2.824-2.31 1.027-2.31 1.027-2.569.257-2.825 0 .771 3.082.771 3.082V218l-.256 3.85s0 1.798-.259 2.055c-.256.256-.77 1.027-.77 1.027l-.256 3.852 4.108 1.026-.257 2.312-2.825.256.515 15.661 4.108.77v4.365l-1.798 1.026-.513 15.661h-14.378zm-31.582.517V255.23l-1.54-1.283v-3.594l2.825-.257.513-16.945-1.798-1.028-.256-2.823s2.054.77 2.054.256.513-3.338.513-3.338-1.283-.256-1.283-.77 1.54-1.797 1.54-1.797-.77-.77-1.027-1.284-.77-2.823-.77-2.823l.77-2.825-.513-1.54-1.284-2.311 1.797-1.798s-.513-2.31-.513-2.823 1.283-2.567 1.54-2.825c.257-.256 2.311-3.08 2.311-3.08l4.364-1.028 5.136.772 2.823 1.797.513 4.62s-.513 2.824-.77 2.824-2.31 1.028-2.31 1.028-2.568.256-2.825 0 .771 3.081.771 3.081v3.08l-.256 3.851s0 1.798-.258 2.054c-.257.257-.77 1.028-.77 1.028l-.256 3.85 4.107 1.027-.256 2.312-2.825.256.514 15.661 4.108.77v4.366l-1.797 1.026-.513 15.66H309.94z"
                fillRule="evenodd"
                stroke="#a9a9a9"
                strokeWidth={1.111}
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                d="M282.923 269.495v-11.938h6.686v12.416l-6.686-.478zm31.515.949l.238-12.178h5.97v11.938l-6.208.24zm31.048-.233l-.478-11.46 6.448-.24v11.94l-5.97-.24zm-60.898-36.062h3.82v6.208h-3.82zm30.332.25h5.254v5.97h-5.253zm31.033.466h4.537v5.73h-4.537z"
            />
            <path
                d="M286.57 206.965c4.108 4.62 4.365 4.62 4.365 4.62m26.185-4.62c.769 1.539 2.053 4.877 3.594 5.133m29.27-4.368s1.284 3.595 3.081 4.108"
                stroke="#a8a8a8"
                strokeWidth={1.111}
                fill="none"
            />
            <path
                d="M282.206 194.022c12.012-3.883-2.806-11.648-5.267 0-3.886.628-4.389 3.511-12.789 2.259-20.313 33.102-5.267 86.518 54.169 141.816-106.457-90.594-63.194-157.604-33.714-155.077 16.034 1.096 7.945 21.096-2.399 11.002z"
                fillRule="evenodd"
                fill="#b97700"
            />
            <path
                d="M285.554 177.049s9.781 2.633 9.781 6.77m-.003-7.52s6.771 3.008 8.275 5.642m45.144-4.509s-8.653 1.129-10.534 3.76m-2.642-3.011s-4.888 4.138-4.514 5.265m3.399 12.791c-.753-.376-4.138-4.89-3.387-10.533m-29.728 7.536s2.257-2.634 2.257-7.525m13.551-1.887l.376 10.909m9.401-1.497c0-.754 3.01-7.9-.376-11.286m-20.312-1.507s-2.633 7.147-.75 13.165m19.939-6.769s-4.137 1.128-6.02 3.01m-11.669-1.894c0-.375 4.514-1.128 6.018 1.506"
                stroke="#7d6c00"
                strokeWidth={2.369}
                fill="none"
            />
            <path
                d="M300.63 301.86c.19.096 3.745-.674 3.745-2.403 1.826-1.152.48-4.419.48-4.419l-3.361-.673-4.613-5.187c-.223-1.6.322-3.104-.671-4.802-3.17.833-4.995 3.49-6.053 6.531.77.962.866 2.018 2.307 2.882 1.504.257 2.528-.64 3.938-.383.736 1.28.51 2.37.767 3.555 1.923 1.344 2.307 3.266 3.46 4.898zm-4.132-22.188v-6.148l-4.419-.193c-.545.93-1.57 1.378-2.21 2.21l-3.074 1.538c1.281 1.537 2.85 2.402 3.843 3.17 2.242.673 4.1.673 5.86-.577zm-13.842 9.128l-2.402-4.036c1.473-.48 3.33-.288 4.707.289 0 0 1.058 2.498.289 3.458-.385.864-2.69.48-2.594.29zm36.512 4.131c1.281-.64 2.466-1.76 2.69-3.361l-4.419-5.092-4.034-.095c-.928-.961-2.434-1.153-3.65-1.153 0 0 1.25 1.92 2.882 2.306 1.153 2.591 6.148 7.395 6.531 7.395zm4.332.567c0-.095 3.937-1.441 6.05-1.248-.19-1.634 2.979-5.38 2.979-5.38l5.572 7.3c-1.025.865-2.819.577-4.228.865 0 0-2.69 2.594-2.978 2.69s-5.187 1.248-7.59-.191c-1.055-2.018.29-4.325.194-4.036zm3.164-12.776c.673-2.337.864-4.676 0-7.59 0 0-6.341-.096-6.341 0s-4.226 1.921-4.226 2.018 1.346 4.13 2.978 3.746c.736 2.146 2.913 1.6 3.938 2.402 1.217-.192 2.433-.385 3.651-.576zm24.886-6.43c-.865 2.659-1.345 5.509-.097 8.07 1.153.192 2.498.96 3.555.768l5.092-9.223c-3.523-1.12-6.373-.992-8.55.385z"
                fillRule="evenodd"
                fill="#c76e2e"
            />
            <path
                d="M353.115 193.19c-12.011-3.884 2.807-11.65 5.267 0 3.886.627 4.39 3.51 12.79 2.258 20.313 33.102 5.266 86.518-54.17 141.816 106.457-90.594 63.194-157.604 33.715-155.077-16.034 1.096-7.946 21.096 2.398 11.002z"
                fillRule="evenodd"
                fill="#b97700"
            />
            <path
                d="M354.331 284.67c-.191 0-3.073 2.112-3.073 2.112-1.378.544-2.753 1.089-4.13 1.634l-4.42.095-.961-3.074 3.363-2.978c-2.85-.416-5.7.705-7.974 2.787 0 0 0 3.361 1.922 4.995 1.153 1.44 4.514 4.035 4.514 4.035 2.114.416 4.131.063 5.476-1.058 1.76-2.85 3.523-5.699 5.283-8.549zm-23.253 30.165c1.443.385 11.337-12.776 11.337-12.776-.865-2.465-2.787-4.259-4.9-5.38 0 0-4.805 5.667-4.9 7.589-.767 1.729-2.976 8.357-2.017 9.223-.096.192-.48 2.88.48 1.344z"
                fillRule="evenodd"
                fill="#c76e2e"
            />
            <path
                strokeLinejoin="round"
                d="M266.366 317.4c-14.817-12.887-34.809-19.991-62.716-10.35 7.51 3.248 15.628 4.364 22.529 7.915l40.187 2.435z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.369}
                fill="#006800"
            />
            <path
                d="M223.44 308.256c29.227.608 37.752 7.913 36.23 6.696"
                stroke="#00a400"
                strokeLinecap="round"
                strokeWidth={2.22}
                fill="none"
            />
            <path
                strokeLinejoin="round"
                d="M266.965 318.916c-8.728 1.724-20.804 10.154-24.356 9.741-9.54-1.11-18.454-4.975-27.704-7.915-3.842-1.221-7.713 0-11.57 0 32.78-15.526 43.943-13.396 63.63-1.826z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.22}
                fill="#006800"
            />
            <path
                strokeLinejoin="round"
                d="M245.361 296.08s-10.959 1.52-15.83 1.825c-4.873-.303-11.955-4.842-19.79-13.09-4.088-4.48-13.395-3.958-13.395-3.958 20.602-4.365 36.634-.204 49.015 15.222zm-14.925-21.305c-14.92-.914-33.49-14.308-37.751-30.139-.002.202 5.479 3.45 4.566 4.263 24.457 6.19 26.081 11.161 33.185 25.876zm24.969 25.569c2.13-13.498 2.74-22.427-3.653-30.444-5.277-6.09-6.596-9.743-10.35-18.268-1.116 17.76-4.974 32.474 14.003 48.712zm-23.453-37.445c11.06-16.136 12.99-28.314 11.264-47.494-.305 1.522-3.958 10.96-4.261 10.96-16.44 10.35-9.133 26.488-7.003 36.534z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.369}
                fill="#006800"
            />
            <path
                strokeLinejoin="round"
                d="M222.225 184.96c11.06 16.136 9.336 31.36 7.61 50.54-.305-1.523-3.958-10.96-4.26-10.96-16.441-10.351-5.48-29.534-3.35-39.58z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.369}
                fill="#006800"
            />
            <path
                strokeLinejoin="round"
                d="M231.353 209.93c26.79-13.498 16.438-30.648 21.31-43.84-18.57 13.802-21.006 28.515-21.31 43.84z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.369}
                fill="#006800"
            />
            <path
                d="M235 206.581c3.35-9.437 10.048-25.573 10.656-25.573m-18.568 45.362c-.608-6.7-3.956-24.662-4.26-26.488"
                stroke="#00a400"
                strokeLinecap="round"
                strokeWidth={2.22}
                fill="none"
            />
            <path
                strokeLinejoin="round"
                d="M228.304 256.502c-14.92-.914-31.055-21.31-35.316-37.141-.001.201 5.479 3.45 4.566 4.262 21.412 9.538 23.646 18.165 30.75 32.88zm-4.43-14.008c-11.06-16.136-12.99-28.314-11.264-47.494.305 1.522 3.958 10.96 4.261 10.96 16.44 10.35 9.133 26.488 7.003 36.534zm9.911-28.3c27.703-12.28 19.178-25.167 27.399-38.665-18.571 13.802-27.095 23.34-27.4 38.665z"
                fillRule="evenodd"
                stroke="#004100"
                strokeWidth={2.369}
                fill="#006800"
            />
            <path
                d="M235 211.445c11.266-11.265 15.223-20.703 15.223-20.703"
                stroke="#00a400"
                strokeLinecap="round"
                strokeWidth={2.22}
                fill="none"
            />
            <g fillRule="evenodd">
                <path
                    d="M333.56 366.355l13.49.275c-44.787-41.942-130.599-60.205-118.667-137.39-12.298 83.701 70.117 91.41 105.177 137.115z"
                    stroke="#e9bf00"
                    strokeWidth={2.369}
                    fill="#ffe100"
                />
                <path
                    d="M235.417 212.661a4.298 4.298 0 11-8.596 0 4.298 4.298 0 018.596 0zm-2.632 23.636a4.06 4.06 0 11-8.118 0 4.06 4.06 0 018.118 0zm3.815 33.681a3.582 3.582 0 11-7.164 0 3.582 3.582 0 017.164 0zm31.276 37.245a3.582 3.582 0 11-7.163 0 3.582 3.582 0 017.163 0zm4.536 10.684a3.582 3.582 0 11-7.163 0 3.582 3.582 0 017.163 0z"
                    stroke="#68300e"
                    strokeWidth={1.111}
                    fill="#9d4916"
                />
            </g>
            <g fillRule="evenodd" fill="#fff">
                <g stroke="#000" strokeWidth={1.111}>
                    <path d="M288.203 349.032c-2.355-2.134-3.853-3.503-4.777-5.828l-14.044-1.528c-.063 2.675-.126 5.349-.191 8.024l19.012-.668z" />
                    <path
                        strokeLinejoin="round"
                        d="M185.313 339.57c8.157 1.507 20.456-.752 24.472 4.518 4.822 5.465-15.093 13.872-12.241 18.6 6.16 6.517 12.5 3.83 19.394.226 1.624-3.523 2.878-9.804 3.766-11.672-2.51-5.773-9.253-8.601-7.53-17.32 11.37-4.249 33.23-3.897 35.583-2.258 1.848 3.623.187 5.273.564 8.16-1.883 3.64-6.728 9.81-6.738 13.074 11.93 4.203 15.074-.648 25.806-.363 12.575.155 20.225 3.531 22.955-1.467-1.87-4.315-13.403-.805-17.78-3.577-2.19-.74-3.604-2.5-5.496-4.44s-7.21-2.04-8.007-6.817c2.225-10.214 16.965-8.653 19.375-10.217l38.405 2.635c6.957-.196 10.892 12.323 1.497 16.09-9.394 3.767-37.18-5.588-49.233.842-.623-2.622-9.283-6.588-9.907-6.713-3.69 1.105-10.88.7-10.88.7-1.758 3.263-3.764 5.652-5.521 8.915-7.975-3.497-15.514 2.715-24.224.874 0 0-13.178 1.506-13.554 1.506s-8.658-.753-8.658-.753c-4.393 1.254-8.785 2.51-13.178 3.765l9.412-8.284-8.282-6.023z"
                    />
                    <path d="M184.732 337.954a3.63 3.63 0 11-7.26 0 3.63 3.63 0 017.26 0zm-.952 17.957a3.63 3.63 0 11-7.26 0 3.63 3.63 0 017.26 0z" />
                </g>
                <g stroke="#000" strokeWidth={1.111}>
                    <path d="M346.253 349.097c2.355-2.134 3.852-3.503 4.777-5.828l14.043-1.528.192 8.024-19.012-.668z" />
                    <path
                        strokeLinejoin="round"
                        d="M449.143 339.636c-8.157 1.506-20.457-.753-24.473 4.517-4.822 5.465 15.093 13.872 12.242 18.6-6.16 6.517-12.5 3.83-19.394.226-1.624-3.523-2.878-9.804-3.766-11.671 2.51-5.774 9.253-8.602 7.53-17.32-11.371-4.25-33.23-3.898-35.584-2.26-1.847 3.624-.187 5.274-.563 8.161 1.882 3.64 6.728 9.81 6.738 13.074-11.93 4.203-15.075-.648-25.807-.363-12.574.155-20.225 3.531-22.955-1.467 1.87-4.315 13.404-.805 17.781-3.577 2.19-.74 3.603-2.5 5.496-4.44s7.21-2.04 8.007-6.816c-2.226-10.215-16.966-8.654-19.376-10.218l-38.404 2.635c-6.958-.196-10.892 12.323-1.498 16.091 9.395 3.766 37.18-5.588 49.233.841.623-2.622 9.283-6.588 9.908-6.713 3.69 1.105 10.88.7 10.88.7 1.758 3.263 3.763 5.652 5.52 8.915 7.976-3.497 15.515 2.715 24.225.874 0 0 13.177 1.506 13.554 1.506s8.658-.753 8.658-.753l13.177 3.765c-3.136-2.762-6.274-5.522-9.411-8.284l8.282-6.023z"
                    />
                    <path d="M449.723 338.02a3.63 3.63 0 107.261 0 3.63 3.63 0 00-7.26 0zm.952 17.956a3.63 3.63 0 107.26 0 3.63 3.63 0 00-7.26 0z" />
                </g>
                <path d="M316.986 329.343c-3.231-.606-4.38-.433-6.57-.65-1.715 5.271-3.427 10.541-5.141 15.812 7.938.716 15.29.716 15.29.651-4.816-.976-3.644-15.748-3.579-15.813z" />
            </g>
            <g fontSize={9} fontFamily="Trebuchet MS" fontWeight="bold">
                <text y={344.274} x={448.605} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={344.274} x={448.605}>
                        {'L'}
                    </tspan>
                </text>
                <text y={344.622} x={453.64} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={344.622} x={453.64}>
                        {'I'}
                    </tspan>
                </text>
                <text y={345.056} x={456.678} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={345.056} x={456.678}>
                        {'B'}
                    </tspan>
                </text>
                <text y={345.49} x={462.58} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={345.49} x={462.58}>
                        {'E'}
                    </tspan>
                </text>
                <text y={345.576} x={468.309} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={345.576} x={468.309}>
                        {'R'}
                    </tspan>
                </text>
                <text y={345.403} x={473.952} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={345.403} x={473.952}>
                        {'T'}
                    </tspan>
                </text>
                <text y={344.535} x={479.247} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={344.535} x={479.247}>
                        {'A'}
                    </tspan>
                </text>
                <text y={344.274} x={485.497} transform="translate(-464.91 -233.28) scale(1.6657)">
                    <tspan y={344.274} x={485.497}>
                        {'S'}
                    </tspan>
                </text>
            </g>
            <path
                d="M231.353 318.616c10.047 1.218 24.052.304 30.14-.001m-45.365-34.412c8.525 6.698 27.096 10.654 26.791 10.654m10.654 1.839c-2.74-14.004-5.783-17.353-8.219-26.183M201.82 254.67c14.31 6.393 16.44 10.654 25.573 17.047m5.176-13.999c1.219-17.355 3.654-21.922 7.917-25.88m-38.666-2.12c5.177 5.785 22.225 23.746 22.225 23.746m-7.001-39.587c6.395 4.566 6.395 21.005 6.395 21.005"
                stroke="#00a400"
                strokeLinecap="round"
                strokeWidth={2.22}
                fill="none"
            />
        </svg>
    );
}

export default SvgSm;
